import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import { Layout } from '../components/Layout'
import { SEO } from '../components/SEO'
import { PostSidebar } from '../components/PostSidebar'
import { Comments } from '../components/Comments'
import { PostAudio } from '../components/PostAudio'
import { PostDocument } from '../components/PostDocument'
import config from '../utils/config'

export default function PostTemplate({ data }) {
  const post = data.markdownRemark
  const { tags, categories, title, date, comments_off, author, published } =
    post.frontmatter
  const { thumbnailSrc, audioSrc, documentSrc } = post
  // Frontmatter YAML parses `no`/`yes` as strings, so normalize before checking
  const commentsOff = ['true', 'yes', 'on'].includes(String(comments_off).toLowerCase())

  return (
    <div>
      <Helmet title={`${post.frontmatter.title} | ${config.siteTitle}`} />
      <SEO postPath={post.fields.slug} postNode={post} postSEO />

      <div className="container">
        <div className="grid">
          <div className="article-content">
            <div className="post-header medium width">
              {thumbnailSrc && (
                <div className="header-post-image">
                  <img src={thumbnailSrc} alt="" width={150} height={150} />
                </div>
              )}
              <h1>{title}</h1>
              {(author || published) && (
                <p className="reading-meta">
                  {author && <span className="reading-author">{author}</span>}
                  {author && published && (
                    <span className="reading-separator" aria-hidden="true">
                      ·
                    </span>
                  )}
                  {published && (
                    <span className="reading-published">{published}</span>
                  )}
                </p>
              )}
            </div>
            <section className="segment small">
              {audioSrc && <PostAudio src={audioSrc} />}
              {documentSrc && <PostDocument src={documentSrc} />}
              <div
                id={post.fields.slug}
                className="post-content"
                dangerouslySetInnerHTML={{ __html: post.html }}
              />
            </section>

            <PostSidebar date={date} tags={tags} categories={categories} />

            {!commentsOff && (
              <section id="comments" className="segment comments">
                <h3>Comments</h3>
                <Comments />
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

PostTemplate.Layout = Layout

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      excerpt
      thumbnailSrc
      audioSrc
      documentSrc
      fields {
        slug
      }
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        tags
        categories
        description
        comments_off
        author
        published
      }
    }
  }
`
